import type { Column } from '~components/table-view';

const columns: Column[] = [
  {
    id: 'section.budget.reference',
    header: 'Budget Reference',
    type: 'text',
    deriveValue: (row) => row?.section?.budget?.reference,
  },
  {
    id: 'section.budget.client.full_name',
    header: 'Client Name',
    type: 'text',
    sortable: false,
    deriveValue: (row) => row?.section?.budget?.client?.full_name,
  },
  {
    id: 'start_date',
    header: 'Start Date',
    type: 'date',
  },
  {
    id: 'end_date',
    header: 'End Date',
    type: 'date',
  },
  {
    id: 'service_type_id',
    header: 'Service Type',
    deriveValue: (row) => row.service_type?.name,
    type: 'text',
  },
  {
    id: 'frequency_id',
    header: 'Frequency',
    deriveValue: (row) => row.frequency?.name,
    type: 'text',
  },
  {
    id: 'quantity',
    header: 'Unit Quantity',
    type: 'number',
    classNames: { header: 'header-align-right p-2', cell: 'cell-align-right p-2' },
  },
  {
    id: 'unit_amount',
    header: 'Cost',
    type: 'currency',
    classNames: { header: 'header-align-right p-2', cell: 'cell-align-right p-2' },
  },
  {
    id: 'total_amount',
    header: 'Invoice Cost Total',
    type: 'currency',
    classNames: { header: 'header-align-right p-2', cell: 'cell-align-right p-2' },
  },
];

export default columns;
